import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import CheckableInput from 'components/CheckableInput';

import { URLS } from 'config';

import './styles.scss';
import containerActions from './actions';

export const needData = {
  personal_value: 'For personal',
  to_drive_from_work: 'To drive to and from work',
  for_work: 'For work'
};

class NeedCarPage extends React.Component {
  isChecked = (type) => {
    const idx = this.props.needs.findIndex(el => el === type);

    return idx >= 0;
  }

  selectHand = (e) => {
    this.props.needsChangeHandl(e.target.value);
  };

  render() {
    return (
      <div className="page-cartype">
        <PageTitle>
          Why you need a car?
        </PageTitle>
        <div className="budget-list">

          {
          Object.keys(needData).map(el => (
            <CheckableInput
              name="needscar"
              changeHandl={this.selectHand}
              value={el}
              key={el}
              checked={this.isChecked(el)}
            >
              {needData[el]}
            </CheckableInput>
          ))
        }
        </div>

        {
          !Object.keys(this.props.user).length ? (
            <Button
              isLink
              pathTo={URLS.PHONE}
              disabled={this.props.needs.length <= 0}
            >
              Continue
            </Button>
          ) : (
            <Button
              onClick={this.props.updateUser}
              disabled={this.props.needs.length <= 0}
            >
              Continue
            </Button>
          )
        }
      </div>
    );
  }
}

NeedCarPage.propTypes = {
  // eslint-disable-next-line
  needs: PropTypes.array.isRequired,
  needsChangeHandl: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  needs: state.needs.needs,
  user: state.user.user
});


export default connect(mapStateToProps, containerActions)(NeedCarPage);



// WEBPACK FOOTER //
// ./src/pages/NeedCar/index.js